import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import InvitationTemplateOptionsPanel from "./InvitationTemplateOptionsPanel";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { InvitationTemplateDetailSection } from "./InvitationTemplateDetailSection";
import { InvitationTemplateActivityPanel } from "./activity/InvitationTemplateActivityPanel";
import { InvoiceTemplateDetailSection } from "invoiceTemplate/detail/InvoiceTemplateDetailSection";
import { EmailTemplateDetailSection } from "emailtemplate/Detail/EmailTemplateDetailSection";
import { InvoiceReminderTemplateDetailSection } from "invoiceReminderTemplate/detail/invoiceReminderTemplateDetailSection";

const InvitationTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MessageTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          {viewModel.messageTemplate.section === "invitationTemplate" && <InvitationTemplateDetailSection
            title={viewModel.pageTitle}
            invitationTemplate={viewModel.messageTemplate}
          />}
          {viewModel.messageTemplate.section === "invoiceDocumentTemplate" && <InvoiceTemplateDetailSection
            title={viewModel.pageTitle}
            invoiceDocumentTemplate={viewModel.messageTemplate}
          />}
          {viewModel.messageTemplate.section === "emailTemplate" && <EmailTemplateDetailSection
            title={viewModel.pageTitle}
            emailTemplate={viewModel.messageTemplate}
            mergeFieldTopicLabel={viewModel.mergeFieldTopicLabel}
            availableMergeFieldTopics={viewModel.availableMergeFieldTopics}
          />}
          {viewModel.messageTemplate.section === "reminderTemplate" && <InvoiceReminderTemplateDetailSection
            title={viewModel.pageTitle}
            invoiceReminderTemplate={viewModel.messageTemplate}
          />}
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <InvitationTemplateOptionsPanel
            canDelete={!viewModel.messageTemplate.basicTemplate}
            type={viewModel.type.value}
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            templateId={viewModel.messageTemplate.messageTemplateId}
          />
          <SupportArticlePanel config={viewModel.articlePanelConfig} />
          <InvitationTemplateActivityPanel
            invitationTemplateId={viewModel.messageTemplate.messageTemplateId}
            config={viewModel.activityPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default InvitationTemplateDetailApp;